import types from './actionTypes';

const initialState = {
  loading: false,
  shortLinks: [],
  startDate: null,
  endDate: null,
  error: '',
};

const shortLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_SHORT_LINK_STATE:
      return initialState;
    case types.CREATE_SHORT_LINK.REQUEST:
    case types.FETCH_SHORT_LINKS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_SHORT_LINK.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.FETCH_SHORT_LINKS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        shortLinks: action.shortLinks,
        startDate: action.startDate,
        endDate: action.endDate,
      };
    case types.CREATE_SHORT_LINK.FAILURE:
    case types.FETCH_SHORT_LINKS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default shortLinkReducer;
